import React, { useState, useEffect } from 'react'
import './Dashboards.css'

const DateFilter = ({ to, handleTo, from, handleFrom, error }) => {
  const handleToChange = (event) => {
    handleTo(event.target.value)
  }

  const handleFromChange = (event) => {
    handleFrom(event.target.value)
  }
  return (
    <div className="dates">
      {error && <p>{'Something was wrong with the input please correct it and try again'}</p>}
      <one-ux-text class="one-ux-typography--body-400">From:</one-ux-text>
      <one-ux-input onChange={handleFromChange} placeholder="yyyy-mm-dd" value={from}></one-ux-input>
      <one-ux-text class="one-ux-typography--body-400">To:</one-ux-text>
      <one-ux-input onChange={handleToChange} placeholder="yyyy-mm-dd" value={to}></one-ux-input>
    </div>
  )
}

export default DateFilter
